export default "__VITE_ASSET__kSliQRiS__"